import { Component, input } from '@angular/core';
import { ZiroIcons } from '../models/ziro-icons.enum';

export enum DashboardTileStatus {
  CRITICAL = 'Critical',
  WARNING = 'Warning',
  NEUTRAL = 'Neutral',
  GOOD = 'Good',
}

export interface DashboardTile {
  message: string;
  status: DashboardTileStatus;
  value: number | string;
  reportUrl: string;
  queryParams?: any;
  dataAutomation?: string;
}

@Component({
  selector: 'ziro-dashboard-tile',
  templateUrl: './dashboard-tile.component.html',
  styleUrls: ['./dashboard-tile.component.scss'],
  standalone: false,
})
export class DashboardTileComponent {
  readonly isLoading = input(true);
  readonly tile = input<DashboardTile>();
  TileStatus = DashboardTileStatus;
  ziroIcons = ZiroIcons;
}
